var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    _vm._l(_vm.riskLevelList, function(risk) {
      return _vm.isShow == true
        ? _c(
            "div",
            {
              staticClass: "content-row content-row-column risk-box",
              staticStyle: { width: "50%", padding: "0 0 .1rem .1rem" },
              on: {
                click: function($event) {
                  _vm.setModalInfo(risk)
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-align-center content-row-around",
                  staticStyle: {
                    position: "relative",
                    padding: "1rem 3rem 0 1.5rem",
                    background: "#fff"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "4rem",
                        height: "4rem",
                        "border-radius": ".5rem",
                        overflow: "hidden"
                      }
                    },
                    [
                      _c("canvas", {
                        staticClass: "risk-body",
                        attrs: {
                          "data-key": risk.key,
                          "data-detail": risk.detail
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticStyle: {
                      "margin-left": ".8rem",
                      width: "4rem",
                      height: "4rem",
                      "border-radius": ".5rem"
                    },
                    attrs: { src: _vm.getRiskImg(risk) }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content-row content-row-column auto-width",
                      staticStyle: { flex: "1" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "content-row content-align-center",
                          staticStyle: {
                            width: "222px",
                            "margin-left": "1rem",
                            "margin-bottom": ".2rem",
                            display: "flex",
                            "justify-content": "space-between"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "font-20",
                              staticStyle: {
                                width: "120px",
                                "margin-right": ".5rem",
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                                overflow: "hidden"
                              }
                            },
                            [_vm._v(_vm._s(risk.name))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "font-14",
                              staticStyle: {
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                                overflow: "hidden",
                                "margin-right": ".5rem",
                                color: "#8d8d8d"
                              }
                            },
                            [_vm._v(_vm._s(risk.detail))]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "level-box level-severe font-12",
                              class: {
                                "level-severe": _vm.hClass,
                                "level-mild": _vm.mClass,
                                "level-normal": _vm.nClass
                              },
                              staticStyle: {
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                                overflow: "hidden"
                              }
                            },
                            [
                              _vm.tips.tip === "高风险"
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.$t("heightRisk")))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tips.tip === "潜在风险"
                                ? _c("p", [
                                    _vm._v(_vm._s(_vm.$t("potentialRisk")))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.tips.tip === "正常"
                                ? _c("p", [_vm._v(_vm._s(_vm.$t("normal")))])
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "content-row content-align-end",
                          staticStyle: {
                            "margin-left": "1rem",
                            height: "1.5rem"
                          }
                        },
                        [
                          _c("canvas", {
                            staticClass: "risk-bar",
                            attrs: {
                              "data-value": risk.value,
                              "data-level": risk.level
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "content-row content-row-between font-16 ItemClass",
                          staticStyle: {
                            "margin-left": "1rem",
                            width: "9rem",
                            padding: "0 .5rem"
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                        ]
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-row",
                  staticStyle: {
                    padding: ".8rem 3.3rem 1rem 1.5rem",
                    background: "#fff"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "content-row font-12",
                      staticStyle: {
                        color: "#949494",
                        "flex-wrap": "nowrap",
                        overflow: "hidden"
                      }
                    },
                    _vm._l(risk.risks, function(key) {
                      return _c(
                        "span",
                        {
                          staticClass: "key-box-risk",
                          staticStyle: { "white-space": "nowrap" }
                        },
                        [_vm._v(_vm._s(key.name))]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm._m(0, true)
                ]
              )
            ]
          )
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "content-row-end content-align-end",
        staticStyle: { height: "1rem", "margin-bottom": ".8rem" }
      },
      [_c("div", { staticClass: "down-arrow" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd4fa69a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd4fa69a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Symp_itemIpad.vue
// module id = null
// module chunks = 